import { render, staticRenderFns } from "./JoinForm.vue?vue&type=template&id=77053ac7&scoped=true&"
import script from "./JoinForm.vue?vue&type=script&lang=js&"
export * from "./JoinForm.vue?vue&type=script&lang=js&"
import style0 from "./JoinForm.vue?vue&type=style&index=0&id=77053ac7&scoped=true&lang=css&"
import style1 from "./JoinForm.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77053ac7",
  null
  
)

export default component.exports